export default __webpack_public_path__ + "static/1-cdd3bf886d8c5b40a6d88b3436ffddc5.png";